import { all, put, call, takeLatest } from 'redux-saga/effects';

import * as actions from 'reducer/actionTypes'
import * as api from 'script/api'

export default function* fetchStats(){

	yield all([
		takeLatest(actions.FETCH_GET_STATS_SUMMARY_INFO_REQUEST, getStatsSummaryInfo),
		takeLatest(actions.FETCH_GET_STATS_SUMMARY_CSV_REQUEST, getStatsSummaryCsv)
	])
}

function* getStatsSummaryInfo(params){
	try {
		const result = yield call(api.statsSummaryInfo, params.condition);

		if (result.data.resultCode > 0) {
			yield put ({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				resultCode: result.data.resultCode,
				message: "message.box.info.failed",
				isError: true
			})
		} else {
			yield put ({
				type: actions.FETCH_GET_STATS_SUMMARY_INFO_SUCCESS,
				value: result.data.info,
				condition: params.condition
			})
			// total value
			if (params.condition.pagination.current === 1) {
				yield put ({
					type: actions.SET_STATS_SUMMARY_TOTAL,
					value: result.data.total,
				})
			}
		}
	}
	catch (error) {
		yield put ({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
		yield put ({
			type: actions.FETCH_GET_STATS_SUMMARY_INFO_FAILURE,
			error: error.message
		})
	}
	finally{
		yield put ({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}

function* getStatsSummaryCsv(params){

	try {
		const result = yield call(api.statsSummaryCsv,params);

		if (result.data.resultCode > 0) {
			yield put ({
				type: actions.FETCH_MESSAGEBOX_REQUEST,
				resultCode : result.data.resultCode,
				message: "message.box.download.failed",
				isError: true
			})
		} else {
			result.data.info.unshift(result.data.total[0])
			// return 받는 값은 제품명이 wrtie, calc, show 로 되어있어서 변경하고자 아래와 같이 수정.
            let exportData = result.data.info.map(item => ({
                date: item.date,
                write: item.write,
                Spreadsheet: item.calc,
                Presentation: item.show,
                total: item.total
            }));
			// result.data.summary 로 전달받는 값은 MAU 값 조회 & export 되는 경우에만.
			if (Array.isArray(result.data.summary) && result.data.summary.length > 0) {
				const summaryMap = new Map(
					result.data.summary.map(item => [item.date, item])
				);
				exportData = [...summaryMap.values()];
				// date 열을 가장 앞으로 출력하기 위함.
				exportData = exportData.map(({ date, countByCoedit, countByFile, countByUser, countByView }) => ({
					date,
					countByCoedit,
					countByFile,
					countByUser,
					countByView
				}));
			}
			yield put ({
				type: actions.FETCH_GET_STATS_SUMMARY_CSV_SUCCESS,
				value: exportData
			})
	
			// click CSVLink
			params.event.link.click();
		}
	}
	catch (error) {
		yield put ({
			type: actions.FETCH_MESSAGEBOX_REQUEST,
			message: error.message,
			isError: true
		})
		yield put({
			type: actions.FETCH_GET_STATS_SUMMARY_CSV_FAILURE,
			error: error.message
		})
	}
	finally {
		yield put ({
			type: actions.CLEAR_API_CALL_STATUS
		})
	}
}
